const LEV_ITEMS_COLUMNS = [
  {
    name: "ticketId",
    id: "ticketId",
    label: "Ticket Id",
    widget: "ticketLink",
    width:130
  },
  {
    name: "totalCount",
    id: "totalCount",
    label: "Total Count",
    widget: "text"
  },
  {
    name: "positiveCount",
    id: "positiveCount",
    label: "Positive Count",
    widget: "text"
  },
  {
    name: "passPercentage",
    id: "passPercentage",
    label: "Pass %",
    widget: "text"
  },
  {
    name: "negativeCount",
    id: "negativeCount",
    label: "Negative Count",
    widget: "text"
  },
  {
    name: "negativePercentage",
    id: "negativePercentage",
    label: "Fail %",
    widget: "text"
  },
  {
    name: "priority",
    id: "priority",
    label: "Priority",
    widget: "priority"
  },
  {
    name: "assignee",
    id: "assignee",
    label: "Assigned",
    widget: "assignees"
  },
  {
    name: "createdBy",
    id: "createdBy",
    label: "created By",
    widget: "assignees"
  },
  {
    name: "createdAt",
    id: "createdAt",
    label: "Created At",
    widget: "date"
  }
];


const TESTCASE_COLUMNS = [
  {
    name: "caseId",
    id: "caseId",
    label: "Testcase Id",
    width:130,
    widget: "ticketLink",
    fixed: true
  },
  {
    name: "caseType",
    id: "caseType",
    label: "Case Type",
    widget: "caseType"
  },
  {
    name: "prerequisite",
    id: "prerequisite",
    label: "Prerequisite",
    widget: "richText"
  },
  {
    name: "testData",
    id: "testData",
    label: "Test Data",
    widget: "richText"
  },
  {
    name: "expectedResult",
    id: "expectedResult",
    label: "Expected Result",
    widget: "richText"
  },
  {
    name: "actualResult",
    id: "actualResult",
    label: "Actual Result",
    widget: "richText"
  },
  {
    name: "stepsReproduce",
    id: "stepsReproduce",
    label: "Steps Reproduce",
    widget: "richText"
  },
  {
    name: "description",
    id: "description",
    label: "Description",
    widget: "richText"
  },
  {
    name: "assignee",
    id: "assignee",
    label: "Assigned",
    widget: "assignees"
  },
  {
    name: "createdBy",
    id: "createdBy",
    label: "created By",
    widget: "assignees"
  },
  {
    name: "createdAt",
    id: "createdAt",
    label: "Created At",
    widget: "date"
  }];

export {
  LEV_ITEMS_COLUMNS,
  TESTCASE_COLUMNS
};